<template>
  <router-view v-slot="{ Component }">
    <component :is="Component" :key="rootPath" />
  </router-view>
</template>

<script setup>
  import { computed, inject, provide } from 'vue'
  import { useRoute } from 'vue-router'

  /**
   * You SHOULD NOT remove this component, it is required to have all routes that must activate the same QRouterTab in the ProfessionalHeaderBar in the same tree of routes.
   * The router view must only be redrawn if the prefix of the route change and must not change when only the child router change.
   */

  const route = useRoute()

  const parentDepth = inject('routerViewParentDepth', -1)
  const depth = parentDepth + 1

  const rootPath = computed(() => {
    let rootPath = route.matched[depth]?.path || ''
    for (const param in route.params) {
      rootPath = rootPath.replace(':' + param, route.params[param] || '')
    }

    return rootPath
  })

  provide('routerViewParentDepth', depth)
</script>
